import { Component, OnChanges, Input, ElementRef, OnDestroy, SimpleChanges, OnInit } from '@angular/core';

import { ChartValue } from './chart-value.model';
import { DateHelperService, NumberFormatService } from '../../core/services';
import { ColorService } from "../../shared/color-service";
import { LineChartOptions } from "./line-chart-options.model";

@Component({
	selector: 'line-chart',
	template: `<div data-line-chart style=" padding: 0px; position: relative;"></div>`
})
export class LineChartComponent implements OnChanges, OnDestroy, OnInit {
	@Input() chartValues: ChartValue[];
	@Input() forceChange: any;
	@Input() toolTipText: string = "{0} {1}";
	@Input() options: LineChartOptions;
	private _options: LineChartOptions;
	private tooltipMaxWidth : number = 200; 
	private tooltipShadowOpacity : number = 0.3;

	constructor(private el: ElementRef, private dateHelper: DateHelperService, private colorService: ColorService, private numberFormatService: NumberFormatService) {
	}

	ngOnInit(): void {
		this.initToolTip();
	}

	ngOnChanges(changes: SimpleChanges) {
		let plotArea = $(this.el.nativeElement).find('[data-line-chart]').empty();
		this._options = this.options;
		this._options.legend = {
			show: true,
			container: plotArea.parent().nextAll(this.options.legendSelector).get(0)
		}
		let labels = this.chartValues.map(s => s.label);
		if (labels)
			this._options.colors = this.colorService.getColorsByNames(labels);
		$(plotArea).height(this._options.height);
		$.plot(plotArea, this.chartValues, this._options);
	}

	ngOnDestroy() {
		$("#tooltip").hide();
	}

	private initToolTip(): void {
		if ($("div#tooltip").length === 0) {
			$("<div id='tooltip'></div>").css({
				position: "absolute",
				display: "none",
				"border-top": "3px solid",
				"border-right": "3px solid",
				"border-bottom": "3px solid",
				color: "white",
				padding: "8px",
				"background-color": "#222a33",
				opacity: 1,
				"max-width": this.tooltipMaxWidth + "px",
			}).appendTo("body");
		}

		$(this.el.nativeElement).on("plothover", (event, pos, item) => {
			if (item) {
				var x = item.datapoint[0],
					y = item.datapoint[1];
				
				var color_alpha = item.series.color;
				if(item.series.color.indexOf("rgba") === -1){
					color_alpha = item.series.color.replace(')', ',' + this.tooltipShadowOpacity + ')');
					color_alpha = color_alpha.replace('rgb', 'rgba');
				}
				else{
					// regex to match the last value and replace it with the default opacity
					color_alpha = item.series.color.replace(/,([0-9]\.[0-9]+)\)/, ',' + this.tooltipShadowOpacity + ')');
				}
				
				// display the tooltip on the right/left side
				var tooltipSide = false;
				if($(window).width() - item.pageX < this.tooltipMaxWidth){
					tooltipSide = true;
				}

				var triangleClass = 'triangle';
				var triangleSmallClass = 'triangle-small';
				if (tooltipSide) {
					triangleClass = 'triangle-br';
					triangleSmallClass = 'triangle-small-br';
				}

				var identicItemValues = new Array<ChartValue>(); 
				if (this.chartValues.length > 0){
					for (let i = 0; i < this.chartValues.length; i++) {
						if (this.chartValues[i].data[item.dataIndex] instanceof Array &&
							this.chartValues[i].data[item.dataIndex][0] == x
							&& this.chartValues[i].data[item.dataIndex][1] == y) {
							identicItemValues.push(this.chartValues[i]);
						}
					}
				}
				
				var labels = "<span style='text-overflow: ellipsis; overflow: hidden;white-space: nowrap;line-height:1.2;'>" + identicItemValues[0].label;
				for(let i = 1; i < identicItemValues.length; i++)
					labels += ", " + identicItemValues[i].label ;
				labels += "</span>";

				$("#tooltip").html(
					"<span id='" + triangleClass + "'></span>" + "<span id='" + triangleSmallClass + "'></span>" + this.toolTipText
						.replace("{0}", "<h1>" + this._options.tooltipCurrency + (this._options.roundTooltip === true ? Math.round(y) : this.numberFormatService.formatDecimal(y, this._options.formatTooltip)) + this._options.tooltipSign + "</h1>")
						.replace("{1}", "<span class='small muted' style='clear: both'>on: " + this.dateHelper.convertBackToDateFromTicks(x) + "</span>")
						.replace("{2}", labels)
				)
					.css({
						top: item.pageY + (- $('#tooltip').height() -40),
						left: item.pageX + (tooltipSide ? 0 - $('#tooltip').width() - 20 : this._options.getTooltipLeft(window)),
						"border-color": item.series.color,
						"-webkit-box-shadow": "-1px 0px 43px 9px " + color_alpha,
						"-moz-box-shadow": "-1px 0px 43px 9px " + color_alpha,
						"box-shadow": "-1px 0px 43px 9px " + color_alpha 
					})
					.fadeIn(200);

				if (tooltipSide) {
					$("#triangle-br").css({ "border-color": item.series.color, })
					$("#triangle-small-br").css({ "border-color": item.series.color, });
				} else {
					$("#triangle").css({ "border-color": item.series.color, })
					$("#triangle-small").css({ "border-color": item.series.color,})
				}
			} else {
				$("#tooltip").hide();
			}
		});
	}

}


// WEBPACK FOOTER //
// ./src/app/dashboard/chart/line-chart.component.ts